import { ROLE } from "providers/Auth";

export const roleOptions = [
  {
    value: "admin",
    label: "Admin"
  },
  {
    value: "property_manager",
    label: "Property Manager"
  }
];

export const RoleTitles = {
  [ROLE.Admin]: "Admin",
  [ROLE.PropertyManager]: "Property manager",
  [ROLE.Owner]: "Owner"
};

export const roleLabels = {
  [ROLE.Admin]:
    "Has access to all features and properties. Can invite and manage users",
  [ROLE.PropertyManager]:
    "Has access to assigned features and properties. Can't access 'Screening Settings', 'Rent Reporting', 'Credit Impact', 'Users', 'Statements', 'API', 'PMS Integration' pages",
  [ROLE.Owner]:
    "Has access to all features and properties. Can invite and manage users. Can’t be edited or removed"
};

export const USER_PERMISSION_KEYS = {
  CAN_CHANGE_AVAILABLE_BY_DATE: "can_change_available_by_date",
  CAN_CHANGE_RENT_AMOUNT: "can_change_rent_amount",
  CAN_MAKE_DECISIONS: "can_make_decisions",
  CAN_VIEW_REPORTS: "can_view_reports",
  CAN_CANCEL_APPLICATIONS: "can_cancel_applications",
  CAN_CHANGE_UNIT: "can_change_unit",
  CAN_EDIT_INCOME: "can_edit_income",
  CAN_MANAGE_ALL_PROPERTIES: "can_manage_all_properties",
  CAN_OVERRIDE_DECISION_RECOMMENDATION: "can_override_decision_recommendation",
  CAN_SHOW_FULL_SSN: "can_show_full_ssn",
  CAN_CHANGE_APPLICANT_ROLE: "can_change_applicant_role",
  CAN_SUBSCRIBE_RENTERS: "can_subscribe_renters",
  CAN_EDIT_SUBSCRIPTION_DETAILS: "can_edit_subscription_details",
  CAN_UNSUBSCRIBE_RENTERS: "can_unsubscribe_renters",
  CAN_VIEW_RENTERS_LIST: "can_view_renters_list",
  CAN_VIEW_RENT_REPORTING: "can_view_rent_reporting",
  CAN_VIEW_CREDIT_REPORTING: "can_view_credit_reporting",
  CAN_APPLY_ACTIVE_DISCOUNTS: "can_apply_active_discounts",
  CAN_APPLY_CUSTOM_DISCOUNTS: "can_apply_custom_discounts",
  CAN_RUN_REPORTS_MANUALLY: "can_run_reports_manually",
  CAN_EDIT_APPLICATION_RENT: "can_edit_application_rent",
  CAN_OVERRIDE_APPLICANT_SCREENING_TEMPLATE:
    "can_override_applicant_screening_template",
  BOOM_REPORT_MANAGERS_ALLOWED: "boom_report_managers_allowed",
  CAN_EDIT_DATA: "can_edit_data",
  CAN_ACCESS_REPORTS: {
    KEY: "can_access_reports",
    PERMISSIONS: {
      RENTAL_APPLICATION: "rental_application",
      IDENTITY_VERIFICATION: "identity_verification",
      INCOME_REPORT: "income_report",
      HOUSING_HISTORY_REPORT: "housing_history_report",
      CREDIT_REPORT: "credit_report",
      US_CRIMINAL_REPORT: "us_criminal_report",
      CA_CRIMINAL_REPORT: "ca_criminal_report",
      HOUSING_COURT_REPORT: "housing_court_report",
      ANIMAL_SCREENING: "animal_screening",
      DISCLOSURE: "disclosure",
      ADDITIONAL_DOCUMENTS: "additional_documents"
    }
  }
} as const;
